import type { FaireProductEntity } from "../../entity_types/product";

export const p_qjf79d98xm: FaireProductEntity = {
  token: "p_qjf79d98xm",
  type: "product",
  name: "Isolde Bars",
  brandToken: "b_7rglxgdkwi",
  brandName: "Mountain Maiden Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/17654009616ef17a0e68737a24bed9bf52e4426b527885d52418e88de5b93992.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f89f9ff7e9c721e23d646cb71c54835e53599917a14ce882a06ddafad5039e64.jpeg",
    "https://cdn.faire.com/fastly/54727c65feaa56f56e0e3f29d0b8f6507e77c609122cd04b60a3033dea80789a.jpeg",
  ],
  priceDollars: 39,
  description:
    "An enchanting blend of vibrant hues, brass allure, and intricate beadwork. These long, elegant bars are a canvas of vivid colors, each representing a story within the spectrum.\n \nDimensions-\n2.25 inches long\n0.35 inches wide\n \nBrass (hypoallergenic stud)",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:46.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
